import React from 'react';

const SessionName = ({ className, onChange, value, id }) => (
  <div className={className}>
    <label className="d-b" htmlFor="sessionName" type="text" name="sessionName">
      {t('in_person_training.new_session.name')} *
    </label>
    <input
      className="NewInput NewInput--white NewInput--fw NewInput--tall fz-20"
      name="sessionName"
      aria-label="Session Name Input Field"
      aria-required="true"
      id="sessionName"
      onChange={e => onChange(e, id)}
      placeholder="Enter Session Name"
      value={value}
      maxLength={255}
      required
    />
  </div>
);

export default SessionName;
